import { render, staticRenderFns } from "./CaseStudyCustomerDetails.vue?vue&type=template&id=26635c64&"
import script from "./CaseStudyCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./CaseStudyCustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports